module.exports = __webpack_public_path__ + "static/media/COS_NUXE.dbd7f70e.jpg";